import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AppProviders } from "@/app/providers";
import { AppRouter } from "@/app/router";
import { StaffSessionGate } from "@/features/auth/ui/session-gate";
import "@/app/styles.css";
import "@/i18n";

const root = document.getElementById("root");

if (!root) {
	throw new Error("Root element #root not found");
}

createRoot(root).render(
	<StrictMode>
		<AppProviders>
			<StaffSessionGate>
				<AppRouter />
			</StaffSessionGate>
		</AppProviders>
	</StrictMode>,
);
